import { DEFAULT_CURRENCY_SYMBOL } from "./currencyMap";

/**
 * Returns a string representation of a monetary amount with thousand separators
 * and a configurable currency symbol. Intended for non-JSX contexts where the
 * <Money /> component cannot be used (e.g. chart axis labels).
 *
 * @param {number|string} amount   The numeric value to format.
 * @param {Object}   [options]
 * @param {string}   [options.symbol]    Currency symbol prefix. Defaults to "$".
 * @param {number}   [options.decimals]  Decimal places. Defaults to 2.
 * @param {boolean}  [options.signed]    If true, prefixes "+" or "-" before the symbol.
 * @returns {string}
 */
export const formatCurrency = (
  amount,
  { symbol = DEFAULT_CURRENCY_SYMBOL, decimals = 2, signed = false } = {}
) => {
  const numeric = Number(amount);
  if (!Number.isFinite(numeric)) {
    return `${symbol}0${decimals > 0 ? "." + "0".repeat(decimals) : ""}`;
  }

  const absolute = Math.abs(numeric);
  const fixed = absolute.toFixed(decimals);
  const [intPart, decPart] = fixed.split(".");
  const withThousands = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const body = decPart ? `${withThousands}.${decPart}` : withThousands;

  if (signed) {
    const sign = numeric >= 0 ? "+" : "-";
    return `${sign}${symbol}${body}`;
  }

  return `${numeric < 0 ? "-" : ""}${symbol}${body}`;
};
